export enum EApplicantRole {
  CANDIDAT = "candidat",
  CFA = "cfa",
  ADMINISTRATOR = "administrator",
}

export enum EApplicantType {
  ETUDIANT = "etudiant",
  PARENT = "parent",
}
